import CryptoJS from 'crypto-js';
import { isArray } from 'lodash';
import Dashboard from '../../components/Dashboard/Dashboard';
import BlankPage from '../../components/UI/BlankPage';
import { locationPath } from '../../constants/app-routes';
import { localStorageConstants } from '../../constants/globals';
import userActionsRoutes from '../../constants/user-actions-routes';

export const checkRoute = (component, route, allowedActions) => {
  const action = userActionsRoutes[route];
  if (action && isArray(action)) {
    action.forEach((element) => {
      if (allowedActions?.includes(element)) {
        return;
      }
    });
    return component;
  } else if (action && allowedActions?.includes(action)) {
    return component;
  }
  return window?.location?.pathname !== locationPath.DASHBOARD
    ? BlankPage
    : Dashboard;
};

export const validRoute = (route, allowedActions) => {
  const action = userActionsRoutes[route];
  if (!action) return;
  if (isArray(action)) {
    action.forEach((element) => {
      if (allowedActions?.includes(element)) {
        return true;
      }
    });
  } else if (allowedActions?.includes(action)) {
    return true;
  }
  return false;
};

export const decryptDataCryptoJS = (encryptedData, secretKey) => {
  const combined = Buffer.from(encryptedData, 'base64'); // Decode the Base64-encoded string

  // Extract the IV from the combined data
  const iv = combined.slice(0, 16); // Assuming the IV length is 16 bytes

  // Extract the encrypted data
  const encrypted = combined.slice(16);

  const decryptedData = CryptoJS.AES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(encrypted.toString('base64')),
    },
    CryptoJS.enc.Utf8.parse(secretKey),
    {
      iv: CryptoJS.enc.Base64.parse(Buffer.from(iv).toString('base64')), // Convert IV to Base64 and then to WordArray
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7, // Use the appropriate padding
    }
  ).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

export const getToken = () => {
  return localStorage.getItem(localStorageConstants.JWT_TOKEN);
};
